/* eslint-disable react/no-danger */
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HR from '../../../../components/hr';
import H2 from '../../../../components/h2';
import P from '../../../../components/p';
import Spacer from '../../../../components/spacer';
import LoadingSmall from '../../../../components/loadingSmall';
import AppState from '../../../../store/appstate';
import { getOpportunities, getMyAccount } from '../../../../api/queries';
import { hasAdminRights } from '../../../../auth/shared';
import OpportunitiesMenu from '../../../../layouts/opportunitiesMenu';
import ButtonInner from '../../../../components/buttonInner';

function Opportunities() {
  const opportunities = getOpportunities();
  const history = useHistory();
  const selectedAccount = AppState.useState((s) => s.selectedAccount);
  const myAccount = getMyAccount({
    artistaccountcode: selectedAccount,
  });
  const adminRights = hasAdminRights(myAccount?.data);
  const { t } = useTranslation('other');

  return (
    <div className="flex flex-wrap">
      <div className="xl:w-80 w-full bg-sentric-menu-gray">
        <OpportunitiesMenu />
      </div>
      <div className="flex-1 xl:w-full sentric-shadow-left bg-sentric-content-white lg:p-6 p-4 min-h-50 lg:min-h-screen-minus-header shadow lg:shadow-none order-last">
        <H2>{t('other:browse-opportunities-header')}</H2>
        <Spacer />
        <div className="w-full">
          {opportunities.isLoading
            && <LoadingSmall />}
          {opportunities.isSuccess && opportunities?.data?.length > 0

            && opportunities.data?.map((o) => (
              <>
                <div key={`o${o.ID}`}>
                  <div className="flex items-start flex-wrap">
                    <div className="w-full lg:w-2/3 py-4 order-last lg:order-first">
                      <P className="font-semibold">{o.post_title}</P>
                      <Spacer />
                      <div className="html-content" dangerouslySetInnerHTML={{ __html: o.post_content }} />
                      <Spacer thin />
                      <ButtonInner id="btnOpportunitiesApply" onClick={adminRights ? () => (o.button ? window.open(o.button, '_blank') : history.push(`/opportunities/apply/${o.ID}`)) : undefined} disabled={!adminRights}>{t('other:apply')}</ButtonInner>
                      <Spacer thin />
                    </div>
                    <div className="w-full w-10 md:w-72 pb-8 py-4 pl-4 order-first lg:order-last hidden lg:flex">

                      <img className="w-full rounded-lg" src={o.image} alt={o.post_title} />
                    </div>
                  </div>
                </div>
                <HR className="w-full lg:w-2/3" />
                <Spacer />
              </>
            ))}
        </div>
      </div>
    </div>

  );
}
export default Opportunities;
